import React from 'react';
import './Loading.css';
import { useTranslation } from '../hooks/useTranslation';

interface LoadingProps {
  message?: string;
  fullscreen?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ 
  message, 
  fullscreen = false 
}) => {
  const { t } = useTranslation();
  const displayMessage = message || t('loading.message');
  
  return (
    <div className={`loading-container ${fullscreen ? 'loading-fullscreen' : 'loading-inline'}`}>
      <div className="loading-spinner"></div>
      <p className="loading-text">{displayMessage}</p>
    </div>
  );
};

export default Loading;
